import * as React from 'react';
import './style.scss';
import LoadingBar from '../loadingBar';
import { isMobile } from '@libs/globalVariables';

interface LoadingGradientProps {}

const LoadingGradient: React.FC<LoadingGradientProps> = () => {
    const renderPC = () => {
        return (
            <div className="loading-container">
                <div className="flex">
                    <LoadingBar width={200} height={32} />
                    <LoadingBar width={285} height={50} />
                </div>
                <div>
                    <LoadingBar width={326} height={20} className="mt-14 mb-16" />
                    <LoadingBar width={517} height={20} className="mb-16" />
                    <LoadingBar width={290} height={20} className="mb-32" />

                    <LoadingBar width={326} height={20} className="mb-16" />
                    <LoadingBar width={517} height={20} className="mb-16" />
                    <LoadingBar width={290} height={20} className="mb-32" />

                    <LoadingBar width={326} height={20} className="mb-16" />
                    <LoadingBar width={517} height={20} className="mb-16" />
                    <LoadingBar width={290} height={20} />
                </div>
            </div>
        );
    };

    const renderM = () => {
        return (
            <div className="loading-container">
                <LoadingBar width={280} height={26} className="mb-10" />
                <LoadingBar width={280} height={18} className="mb-8" />
                <LoadingBar width={280} height={18} className="mb-36" />

                <LoadingBar width={147} height={36} className="mb-10" />
                <LoadingBar width={280} height={45} />
            </div>
        );
    };

    return <div>{isMobile ? renderM() : renderPC()}</div>;
};

export default LoadingGradient;
